import { useEffect } from 'react';

export const useBlockBrowserClose = (shouldBlock: () => boolean, callback?: () => void) => {
    useEffect(() => {
        if (!shouldBlock()) {
            return;
        }

        const onBeforeUnload = (event: BeforeUnloadEvent) => {
            callback?.();
            event.preventDefault();

            // deprecated but still needed for older browsers https://developer.mozilla.org/en-US/docs/Web/API/BeforeUnloadEvent/returnValue
            event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
        };

        window.addEventListener('beforeunload', onBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload);
        };
    }, [shouldBlock, callback]);
};
